import { render } from "./FAQView.vue?vue&type=template&id=54b1407a"
import script from "./FAQView.vue?vue&type=script&lang=js"
export * from "./FAQView.vue?vue&type=script&lang=js"

import exportComponent from "/home/zhayrullah/projects/laravel/mawthuq/front-mawthuq/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__